import { Button, Modal } from "react-bootstrap";
import useCreateClientSet from "./hooks/useCreateClientSet";
import { FormInput } from "../../components/forms";

const CreateClientSetModal = ({
    setCount,
    createClientSet,
    onHide,
    ...modalProps
}) => {
    const {
        name,
        setName,
        onCancelClick,
        onCreateClick
    } = useCreateClientSet({ createClientSet, onHide });

    return <Modal centered onHide={onHide} size="md" {...modalProps}>
        <Modal.Header closeButton>
            <Modal.Title>Create Client Set containing {setCount} Accounts</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <FormInput
                label="Set Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                disableAnimations
            />
        </Modal.Body>
        <Modal.Footer>
            <Button variant="success" onClick={onCreateClick}>Create Set</Button>
            <Button variant="light" onClick={onCancelClick}>Cancel</Button>
        </Modal.Footer>
    </Modal>
}

export default CreateClientSetModal;